// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.photo-lower-bar-button-custom[data-v-8d0b0ee6] {\n    display: inline-block;\n    color: #939393;\n    cursor: pointer;\n    user-select: none;\n}\n.light-icon[data-v-8d0b0ee6] {\n    height: 23px;\n    width: auto;\n}\n.photo-lower-bar-button-custom[data-v-8d0b0ee6]:hover {\n    color: #808080;\n}\n.photo-lower-bar-button-custom[data-v-8d0b0ee6]:active {\n    color: #707070;\n}\n", ""]);
// Exports
module.exports = exports;
